import gql from 'graphql-tag'

import { LeadFieldsFragment } from 'main/gql/lead'
import { UserFieldsFragment, UserWithFamilyFieldsFragment } from 'main/gql/user'

export { AddToFavorites } from './__generated__/AddToFavorites'

export const ADD_TO_FAVORITES_QUERY = gql`
  query AddToFavorites {
    leads: leadsForParent {
      ...LeadFields
    }
    user {
      ...UserFields
      ...UserWithFamilyFields
    }
  }

  ${LeadFieldsFragment}
  ${UserFieldsFragment}
  ${UserWithFamilyFieldsFragment}
`
